<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Courses'
    },

    extends: TableView,

    data() {
        const { id: teacherId } = this.$route.params;

        return {
            teacher: {},
            teacherId
        };
    },

    computed: {
        title() {
            return `${this.teacher.fullName}'s Courses`;
        },

        breadcrumbs() {
            return [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Teachers',
                    to: '/teachers'
                },
                {
                    text: this.teacher.fullName,
                    to: `/teachers/${this.teacher.id}/edit`
                },
                {
                    text: 'Courses',
                    active: true
                }
            ];
        },

        labels() {
            return [
                { value: 'name', width: '200px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.teacherId
            };
        }
    },

    async created() {
        try {
            this.teacher = await this.getTeacher(this.teacherId);
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getTeacher: 'teachers/show',
            getItems: 'teachers/getCourses',
            deleteItem: 'courses/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/courses/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push(`/courses/add?teacherId=${this.teacher.id}`);
        }
    }
};
</script>
